var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"support-admin-summary-chart"}},[_c('ErrorPopup',{attrs:{"error":_vm.error}}),_c('CompatibleBarChart',{attrs:{"options":_vm.bar_option,"chartData":_vm.chart_data}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }